import SimplePeer from 'simple-peer'

export const getRemoteDescription = (peer: SimplePeer.Instance): RTCSessionDescription | null | undefined =>
  (peer as { _pc?: RTCPeerConnection })._pc?.remoteDescription

export const isPeerInitiator = (peer: SimplePeer.Instance): boolean =>
  (peer as { initiator?: boolean }).initiator === true

/**
 * based on https://stackoverflow.com/questions/49027287/check-whether-webrtc-peer-connection-is-passing-through-turn-server-or-not
 */
export const isUsingRelay = async (peer: SimplePeer.Instance): Promise<boolean> => {
  const stats = await (peer as any)._pc.getStats()
  const selectedLocalCandidateId = [...stats.values()].find(
    ({ type, state, localCandidateId }) => type === 'candidate-pair' && state === 'succeeded' && localCandidateId
  )?.localCandidateId

  return !!selectedLocalCandidateId && stats.get(selectedLocalCandidateId)?.candidateType === 'relay'
}
